import React from 'react';
import { FormModal, FormField } from '../../../components/ui/Modal';
import { useAddMaterialModal } from './AddMaterialModal.hooks';

interface AddMaterialModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: { nombre: string; descripcion: string }) => Promise<void>;
}

const AddMaterialModal: React.FC<AddMaterialModalProps> = ({ isOpen, onClose, onSave }) => {
  const { formData, loading, error, handleFormChange, handleSave, handleClose } =
    useAddMaterialModal();

  const fields: FormField[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      placeholder: 'Ej. Oro 18k',
      required: true,
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      placeholder: 'Descripción del material...',
      rows: 3,
    },
  ];

  const handleSaveClick = async () => {
    await handleSave(onSave);
  };

  // Convert formData to Record<string, string> for FormModal
  const formDataRecord: Record<string, string> = {
    nombre: formData.nombre || '',
    descripcion: formData.descripcion || '',
  };

  return (
    <FormModal
      open={isOpen}
      onClose={() => handleClose(onClose)}
      title="Agregar Material"
      fields={fields}
      formData={formDataRecord}
      onFieldChange={handleFormChange}
      onSave={handleSaveClick}
      loading={loading}
      error={error}
      saveButtonText="Guardar"
      cancelButtonText="Cancelar"
      maxWidth="sm"
      variant="simple"
    />
  );
};

export default AddMaterialModal;
